export default __webpack_public_path__ + "static/media/logo.fd71e57d.png";